import { Link } from "react-router-dom";
import Logo from "@/assets/uplift logo 2.png"

const cols = [
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Solutions", to: "/solutions" },
      { label: "Process", to: "/process" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Supply & Installation", to: "/solutions" },
      { label: "Technical Solutions", to: "/solutions" },
      { label: "PCB Repair", to: "/solutions" },
      { label: "Maintenance", to: "/solutions" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Spare Parts", to: "/spare-parts" },
      { label: "Testing & Commissioning", to: "/solutions" },
      { label: "Safety Inspection", to: "/solutions" },
      { label: "Programming", to: "/solutions" },
    ],
  },
];

const socials = [
  { icon: "ri-youtube-fill", href: "https://www.youtube.com/@upliftone" },
  { icon: "ri-instagram-line", href: "https://www.instagram.com/upliftone1/" },
  { icon: "ri-facebook-fill", href: "https://www.facebook.com/profile.php?id=61583846889372" },
];

export default function Footer() {
  return (
    <footer className="bg-crest-cream pt-20 pb-8 border-t border-black/5">
      <div className="px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14">
          <div className="md:col-span-12 lg:col-span-5">
            <Link to="/" className="inline-block cursor-pointer">
              <img
                src={Logo}
                alt="Uplift One Elevator Solutions Hub"
                className="h-16 md:h-20 w-auto object-contain"
              />
            </Link>
            <p className="text-crest-deep/70 text-base leading-relaxed mt-5 max-w-md">
              Complete elevator and escalator solutions — from supply and installation to technical support, maintenance, PCB repair, and all-brand spare parts. Serving Abu Dhabi and the UAE.
            </p>

            <div className="flex items-center gap-2 mt-6">
              {socials.map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-crest-deep/15 text-crest-deep hover:bg-crest-deep hover:text-crest-orange transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-4 lg:col-span-2">
              <h4 className="font-display text-sm font-semibold text-crest-deep uppercase tracking-wider mb-4">
                {c.title}
              </h4>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-crest-deep/70 hover:text-crest-deep text-sm cursor-pointer"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-4 lg:col-span-1">
            <h4 className="font-display text-sm font-semibold text-crest-deep uppercase tracking-wider mb-4">
              Location
            </h4>
            <p className="text-crest-deep/70 text-sm leading-relaxed">
              Abu Dhabi – UAE
            </p>
          </div>
        </div>

        <div className="border-t border-crest-deep/10 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-crest-deep/60 text-xs">
            © {new Date().getFullYear()} Uplift One Elevator Solutions Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-xs">
            <a
              href="#"
              className="text-crest-deep/60 hover:text-crest-deep cursor-pointer"
            >
              Privacy
            </a>
            <a
              href="#"
              className="text-crest-deep/60 hover:text-crest-deep cursor-pointer"
            >
              Terms
            </a>
            <a
              href="tel:0505664336"
              className="text-crest-deep/60 hover:text-crest-deep cursor-pointer"
            >
              050 566 43 36
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}